<template>
  <div class="pb-16">
    <template v-if="silo">
      <v-btn
        outlined
        class="text-none mb-4 pl-3 pr-3"
        color="gray12Color"
        style="background: var(--v-whiteColor-base);"
        @click="$router.push(`/sites/${site.id}/campaign/${campaignId}/silo`)"
      >
        <i class="material-icons-outlined mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">arrow_back</i> <span style="color: var(--v-blackColor-base);">Back to Silos</span>
      </v-btn>
      
      <div>
        <div class="mb-1" style="color: var(--v-gray50Color-base); font-size: 1rem;">Silo</div>
        
        <div class="d-flex align-center justify-space-between gap10 mb-4">
          <div class="d-flex align-center gap10">
            <div style="color: var(--v-blackColor-base); font-weight: 700; font-size: 1.5rem; line-height: 1.5;">
              {{silo.name}}
            </div>
            <span
              v-if="silo.pageType"
              class="tag mt-1"
              style="background: none; border: 1px solid var(--v-blackColor-base); color: var(--v-blackColor-base); text-transform: uppercase; font-size: 0.7rem;"
            >
              <template
                v-if="silo.pageType === 'new'"
              >
                New page
              </template>
              <template
                v-else-if="silo.pageType === 'existing'"
              >
                Existing page
              </template>
              <template
                v-else
              >
                {{ silo.pageType }}
              </template>
            </span>
          </div>

          <div class="d-flex align-center gap10">
            <v-btn
              outlined
              class="text-none"
              color="gray12Color"
              style="background: var(--v-whiteColor-base);"
              href="https://help.pageoptimizer.pro/article/difference-between-top-level-and-supporting-content-keywords"
              target="_blank"
            >
              <i class="material-icons mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">school</i> <span style="color: var(--v-blackColor-base);">How to use this dashboard?</span>
            </v-btn>
          </div>
          
        </div>
        
      </div>

      <div
        class="flex white-selected-box h78 justify-space-between mt-4"
        v-if="selectedSiloKeywords?.length"
      >
        <div class="box-primary-bg d-flex align-center">
          <div class="count-value px-5">
            {{ selectedSiloKeywords?.length || 0 }}
          </div>
        </div>
        <div class="px-3 d-flex align-center">
          <div class="selected-text">item{{ selectedSiloKeywords?.length === 1 ? '':'s'}} selected</div>
        </div>
        <div class="d-flex flex-wrap align-center">
          <div class="flex gap15 align-center fill-height">
            <span
              v-if="isWhiteGloveUser && $refs?.['silo-result-table']?.isContentOrderEditable && $refs?.['silo-result-table']?.isValidKeywordSelection?.(selectedSiloKeywordsRows)"
              class="flex flex-column align-center cursor-pointer" style="width: 6rem;"
              @click="orderContentForSelectedKeywords()"
            >
              <i class="material-icons-outlined orange-color">shopping_basket</i>
              <div class="action-title">Order content</div>
            </span>
            <span
              v-if="!isWhiteGloveUser || (isWhiteGloveUser && isMissionControlSession)"
              class="flex flex-column align-center cursor-pointer w78"
              @click="bulkMovePopUp = true"
            >
              <i class="material-icons-outlined orange-color">swap_horiz</i>
              <div class="action-title">Move to another silo</div>
            </span>
            <span
              v-if="isWhiteGloveUser && isMissionControlSession"
              class="flex flex-column align-center cursor-pointer w78"
              @click="openBulkModal()"
            >
              <i class="material-icons-outlined orange-color">sync</i>
              <div class="action-title">Create POP run reports</div>
            </span>
            <!--<span
              v-if="isWhiteGloveUser && isMissionControlSession"
              class="flex flex-column align-center cursor-pointer w78"
            >
              <i class="material-icons-outlined flip-icon orange-color">list</i>
              <div class="action-title">Create AI Writer outlines</div>
            </span>-->
            <span
              v-if="!isWhiteGloveUser || (isWhiteGloveUser && isMissionControlSession)"
              class="flex flex-column align-center cursor-pointer w78"
              @click="bulkTrackKeyword()"
            >
              <i class="material-icons orange-color">add_circle_outline</i>
              <div class="action-title">Track</div>
            </span>
            <span
              v-if="!isWhiteGloveUser || (isWhiteGloveUser && isMissionControlSession)"
              class="flex flex-column align-center cursor-pointer w78"
              @click="bulkRemoveKeyword()"
            >
              <i class="material-icons-outlined orange-color">delete</i>
              <div class="action-title">Remove</div>
            </span>
            <span
              v-if="isWhiteGloveUser && isMissionControlSession"
              class="flex flex-column align-center cursor-pointer w78"
            >
              <img
                src="/static/star_group.svg"
                style="width: 24px; height: 24px"
              />
              <div class="action-title">Create AI Writer articles</div>
            </span>
            <div
              class="cross-container flex justify-center align-center fill-height px-5"
            >
              <i @click="resetSelectedSiloKeywords" class="material-icons cursor-pointer">close</i>
            </div>
          </div>
        </div>
      </div>

      <silo-result-table
        ref="silo-result-table"
        :siteId="siteId"
        :silo="silo"
        :site="site"
        :silo_keywords="silo_keywords.filter(k => !k.isDeleted)"
        :deleted_silo_keywords="silo_keywords.filter(k => k.isDeleted)"
        :refreshData="loadData"
        :allOrderedSiloKeywords="allOrderedSiloKeywords"
        @onKeywordRemoveSuccess="onKeywordRemoveSuccess"
        @onKeywordRestoreSuccess="onKeywordRestoreSuccess"
      />

      <bulk-run-modal :bulkPopUp="bulkPopUp" @submit="createBulkReport" @closeModal="closeBulkModal" />

      <bulk-move-to-silo-modal
        v-if="bulkMovePopUp"
        :silo="silo"
        :silo_keywords="silo_keywords"
        :selectedSiloKeywords="selectedSiloKeywords"
        @close="bulkMovePopUp = false"
        @success="resetSelectedSiloKeywords(); loadData()"
      />
    </template>
  </div>
</template>

<script>
import SiloResultTable from '@/components/Campaigns/silo/SiloResultTable.vue';
import BulkRunModal from '@/components/BulkRunModal.vue';
import BulkMoveToSiloModal from '@/components/Campaigns/silo/BulkMoveToSiloModal.vue';
import { getPureServicePkgName, getHostName } from '@/utils';
import {
  whiteGlovePlans,
} from "@/components/plans_constants"
import rockyKeywordScreenMixin, {
  KEYWORD_SCREENS,
  MAX_TABLE_ROWS,
  mapSiloKeywordRow,
  summarize,
  short as rockyShort,
} from '../rockyKeywordScreen.js';

const channel = new BroadcastChannel('silo_content_editor_channel');
const aiWriteChannel = new BroadcastChannel('silo_ai_writer_channel');

export default {
  mixins: [rockyKeywordScreenMixin],
  props: ['campaignId', 'currentCampaign'],
  components: {
    SiloResultTable,
    BulkRunModal,
    BulkMoveToSiloModal,
  },
  data() {
    return {
      silo: null,
      silo_keywords: [],
      bulkPopUp: false,
      bulkMovePopUp: false,
      silos: [],
      quickContentSilos: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
    selectedSiloKeywords() {
      return this.$store.getters.selectedSiloKeywords;
    },
    selectedSiloKeywordsRows() {
      return this.silo_keywords.filter(siloKeyword => this.selectedSiloKeywords.includes(siloKeyword.id))
    },
    curSiloId() {
      return this.$route.query.id?Number(this.$route.query.id):null;
    },
    site () {
      return this.$store.getters.siteById(parseInt(this.$route.params.siteId)) || {};
    },
    siteId () {
      return parseInt(this.$route.params.siteId);
    },
    allOrderedSiloKeywords() {
      return [
        ...this.silos.filter(silo => silo?.content_report_order && silo?.content_report_order?.order_status !== 'user_editing').flatMap(silo => silo.silo_keywords.filter(k => !k.isDeleted).map(siloKeyword => siloKeyword.keyword)),
        ...this.quickContentSilos.filter(silo => silo?.content_report_order && silo?.content_report_order?.order_status !== 'user_editing').flatMap(silo => silo.silo_keywords.filter(k => !k.isDeleted).map(siloKeyword => siloKeyword.keyword))
      ]
    },
  },
  methods: {
    bulkRemoveKeyword() {
      const selectedSiloKeywords = [...this.selectedSiloKeywords]
      this.$refs['silo-result-table'].keywordsOngoingRemoval = [...this.$refs['silo-result-table'].keywordsOngoingRemoval, ...selectedSiloKeywords]
      this.$store.dispatch('bulkRemoveKeywordFromSilo', {
        siloId: this.silo.id,
        keywordIds: selectedSiloKeywords
      })
      .then(response => {
        if (response?.data?.status === 'SUCCESS') {
          return this.loadData(true)
        }
        this.$notify({
          group: 'info',
          type: 'error',
          text: response?.data?.msg || 'Failed!',
        });
      })
      .finally(() => {
        this.$refs['silo-result-table'].keywordsOngoingRemoval = this.$refs['silo-result-table'].keywordsOngoingRemoval.filter(k => !selectedSiloKeywords.includes(k))
        this.resetSelectedSiloKeywords();
      })
    },
    bulkRestoreKeyword() {
      const selectedSiloKeywords = [...this.selectedSiloKeywords]
      this.$refs['silo-result-table'].keywordsOngoingRemoval = [...this.$refs['silo-result-table'].keywordsOngoingRemoval, ...selectedSiloKeywords]
      this.$store.dispatch('bulkRestoreSiloKeyword', {
        siloId: this.silo.id,
        keywordIds: selectedSiloKeywords
      })
      .then(response => {
        if (response?.data?.status === 'SUCCESS') {
          return this.loadData(true)
        }
        this.$notify({
          group: 'info',
          type: 'error',
          text: response?.data?.msg || 'Failed!',
        });
      })
      .finally(() => {
        this.$refs['silo-result-table'].keywordsOngoingRemoval = this.$refs['silo-result-table'].keywordsOngoingRemoval.filter(k => !selectedSiloKeywords.includes(k))
        this.resetSelectedSiloKeywords();
      })
    },
    bulkTrackKeyword () {
      const selectedKeywords = this.silo_keywords.filter(siloKeyword => this.selectedSiloKeywords.includes(siloKeyword.id))
      let data = {
        campaignId: this.campaignId,
        trackKeywords: selectedKeywords,
        languageCode: this.currentCampaign.languageCode,
        locationCode: this.currentCampaign.locationCode,
        domain: getHostName(this.currentCampaign.targetUrl)
      }
      this.$store.commit('showLoading');
      this.$store.dispatch('bulkTrackKeywordToTrack', data)
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          response.data.added && this.$store.commit('setIsNewTrackingUpdates', true);
          this.$refs['silo-result-table'].loadKeywordTrack()
          this.$notify({
            group: 'info', type: 'success',
            text: response.data.added ? 'POP is now tracking these keywords.' : 'Keywords are removed from tracking.'
          })
        } else {
          this.$notify({
            group: 'info', type: 'error',
            text: 'Failed to update keywords.'
          })
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading')
        this.resetSelectedSiloKeywords();
      })
    },
    orderContentForSelectedKeywords() {
      const selectedKeywords = this.silo_keywords.filter(siloKeyword => this.selectedSiloKeywords.includes(siloKeyword.id))

      const topLevelKeywordIds = selectedKeywords.filter(row => row.keywordData.isTopLevelKeyword).map(row => row.id)
      const supportingKeywordsIds = selectedKeywords.filter(row => row.keywordData.isSupportingKeyword).map(row => row.id)

      this.$store.dispatch('updateSiloContentReportOrder', {
        orderId: this.silo.content_report_order.id,
        body: {
          selected_top_level_keyword_ids: topLevelKeywordIds,
          selected_supporting_keyword_ids: supportingKeywordsIds
        }
      })
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            this.loadData(true)
            this.resetSelectedSiloKeywords();
            this.$refs['silo-result-table'].showContentOrderFormModal = true
          }
        })
    },
    createBulkReport() {
      const selectedKeywords = this.silo_keywords.filter(siloKeyword => this.selectedSiloKeywords.includes(siloKeyword.id))
      const body = selectedKeywords.map(siloKeyword => {
        const isTopLevel = siloKeyword.keywordData.isTopLevelKeyword;
        const config = this.site.settings;
        const url = siloKeyword.keywordData.page || siloKeyword.keywordData.currentRankingUrl

        return {
          "silo_keyword_id": siloKeyword.id,
          "project_name": this.site.name,
          "proxy_location": config.proxyLocation,
          "target_language": config.targetLang,
          "ignore_spaces": config.ignoreSpaces,
          "page_name": siloKeyword.keyword,
          "competitor_urls": [],
          "page_not_built": isTopLevel && url ? 0 : 1,
          "keyword": siloKeyword.keyword,
          "url": url || this.site.baseURL,
          "tab_name": "silo bulk run",
          "variations": [],
          "pop_pick_competitors": "yes",
        }
      })
      this.$store.commit('showLoading')
      this.$store.dispatch('generateNewBulkRun', body)
      .then((response) => {
        if (response.data && response.data.status == 'SUCCESS') {
          const bulkRunId = response.data.bulkRun.id;
          this.$store.dispatch('createNewBulkRun', { bulkRunId, isSilo: true }).then(() => {
            this.loadData();
          });
          this.closeBulkModal();
          this.resetSelectedSiloKeywords();
        } else if (response.data && response.data.msg) {
          this.$notify({ group: 'info', type: 'error', text: response.data.msg, duration: 5000 })
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading')
      })
    },
    closeBulkModal() {
      this.bulkPopUp = false;
    },
    openBulkModal() {
      this.bulkPopUp = true;
    },
    resetSelectedSiloKeywords() {
      this.$store.commit('resetSelectedSiloKeywords');
    },
    fetchSilos() {
      // only keyword names/labels + order status are read from these lists
      return this.$store.dispatch('getSilos', {
        campaignId: this.$route.params.campaignId,
        paginate: 0,
        includeKeywords: 1,
        includeAiAndPageRunResult: 0,
        includeGuardDiffData: 0,
        includePage: 0,
      }).then(response => {
        this.silos = response.data.data;
        return this.$store.dispatch('getSilos', {
          campaignId: this.$route.params.campaignId,
          paginate: 0,
          isForQuickContentOrder: 1,
          includeKeywords: 1,
          includeAiAndPageRunResult: 0,
          includeGuardDiffData: 0,
          includePage: 0,
        }).then(response => {
          this.quickContentSilos = response.data.data;
          return
        })
      })
    },
    loadData(silent = false) {
      if (!silent) {
        this.$store.commit('showLoading');
      }
      return this.$store
        .dispatch('getSilo', this.curSiloId)
        .then((response) => {
          if (response.data.data?.isForQuickContentOrder) {
            // this is a quick content order, redirect to the correct route
            this.$router.push(`/sites/${this.siteId}/quick-content-orders?id=${response.data.data.id}`);
          } else {
            this.silo = response.data.data;
            return this.$store.dispatch('getSiloKeywords', {
              silo_id: this.curSiloId,
              paginate: 0,
              includeDeleted: 1,
              includeAiAndPageRunResult: 1,
              includeGuardDiffData: 0,
            })
            .then((response) => {
              this.silo_keywords = response.data.data;
            })
            .then(() => this.fetchSilos())
          }
        })
        .finally(() => {
          if (!silent) {
            this.$store.commit('hideLoading');
          }
        });
    },
    onKeywordRemoveSuccess(keywordId) {
      this.silo_keywords = this.silo_keywords.map(siloKeyword =>( {
        ...siloKeyword,
        isDeleted: siloKeyword.id === keywordId ? true : siloKeyword.isDeleted
      }))
    },
    onKeywordRestoreSuccess(keywordId) {
      this.silo_keywords = this.silo_keywords.map(siloKeyword =>( {
        ...siloKeyword,
        isDeleted: siloKeyword.id === keywordId ? false : siloKeyword.isDeleted
      }))
    },
    // Rocky snapshot of the silo keyword table (top-level keywords first,
    // matching the rendered grouping).
    buildRockyScreenData() {
      const active = this.silo_keywords.filter(k => !k.isDeleted);
      const sorted = [...active].sort((a, b) => {
        const rank = (k) => (k.keywordData?.isTopLevelKeyword ? 0 : 1);
        return rank(a) - rank(b);
      });
      return {
        screen: KEYWORD_SCREENS.SILO_DETAIL,
        status: this.silo ? (active.length ? 'ready' : 'empty') : 'loading',
        loading: !this.silo,
        recordIds: { siloId: this.curSiloId },
        data: {
          siloName: this.silo ? rockyShort(this.silo.name) : null,
          pageType: this.silo?.pageType != null ? this.silo.pageType : null,
          rows: summarize(sorted, mapSiloKeywordRow, MAX_TABLE_ROWS),
          buckets: {
            topLevelCount: active.filter(k => k.keywordData?.isTopLevelKeyword).length,
            supportingCount: active.filter(k => k.keywordData?.isSupportingKeyword).length,
            totalCount: active.length,
          },
          deletedCount: this.silo_keywords.filter(k => k.isDeleted).length,
          viewState: {
            selectedKeywordCount: this.selectedSiloKeywords.length,
          },
        },
      };
    },
  },
  watch: {
    silo_keywords () { this.emitRockyKeywordScreen() },
    selectedSiloKeywords () { this.emitRockyKeywordScreenDebounced() },
    // query.id can change without destroying the component (silo → silo
    // navigation): reload happens elsewhere, but re-emit for Rocky too.
    curSiloId () { this.emitRockyKeywordScreenDebounced() },
  },
  mounted() {
    this.emitRockyKeywordScreen()
    this.resetSelectedSiloKeywords()
    this.loadData();
    channel.onmessage = (message) => {
      if (message.data === 'flag_updated') {
        this.loadData();
      }
    };
    aiWriteChannel.onmessage = (message) => {
      if (message.data === 'ai_writer_updated') {
        this.loadData();
      }
    };
  },
  beforeDestroy() {
    channel.close();
    aiWriteChannel.close();
  }
};

</script>

<style lang="scss" scoped>
@import './silo.scss';
</style>
